import {AbstractValidator, ValidationOptions} from "@ha/formhandler";
import {Interval} from "luxon";

/**
 * Single source of truth for "is this date range's start not after its end".
 * Used both by this form validator (gates the Save button) and by
 * ha-input-date-range (drives the error border/tooltip) so the two can't drift apart.
 */
export function isDateRangeOrderValid(value: Interval | null | undefined): boolean {
    if (!value) {
        return true;
    }

    return value.isValid && value.count(`days`) >= 1;
}

export class DateRangeOrderValidator extends AbstractValidator<Interval, ValidationOptions<Interval>> {

    protected get defaultValidationMessage(): string {
        return `Das Startdatum darf nicht nach dem Enddatum liegen.`;
    }

    protected validate(value: Interval): boolean {
        return isDateRangeOrderValid(value);
    }

}
